import React, { type FC } from 'react';
import { Text } from '@is24at/react-ui-core';
import { ChevronRight } from 'common/Icons';
import styles from './Link.scss';

export const Link: FC<
  React.PropsWithChildren<{
    href: string;
  }>
> = ({ href, children }) => (
  <Text<'a'> className={styles.link} tag="a" href={href} color="gray">
    {children}
    <ChevronRight size={12} color="gray" />
  </Text>
);
